import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export const Header = {
	
	props : {
		container: document.querySelector('.Header'),
		starterHeight: document.querySelector('.Header').clientHeight
	},

	init: () => {
			// vars
			Header.$voile = document.querySelector('.Voile');
			Header.$toggle = document.querySelector('.Header_toggle');
		
			// gestion fermer / ouver sur mobile
			Header.$voile.removeEventListener('click', () => Header.toggleMenu());
			Header.$toggle.addEventListener('click', () => Header.toggleMenu());
			
			// gestion de la taille
			Header.tiny();
			window.addEventListener("scroll", Header.tiny);
	},

	tiny(){
		 
		const timer = setTimeout(()=> {
			if(window.scrollY > Header.props.starterHeight){
				Header.props.container.dataset.size = 'tiny';
			}
			else if( window.scrollY <= Header.props.starterHeight ) {
				Header.props.container.dataset.size = 'big';
			}
			clearTimeout(timer);

		}, 30)

	},

	toggleMenu: () => {
		const $header = document.querySelector('.Header');

		if ($header.dataset.state == 'close') {
			Header.$voile.dataset.state = 'true'
			$header.dataset.state = 'open';
			disableBodyScroll($header);

		} else {
			Header.$voile.dataset.state = 'false'
			$header.dataset.state = 'close';
			enableBodyScroll($header)
		}

		Header.$toggle.removeEventListener('click', () => Header.toggleMenu());
		Header.$voile.addEventListener('click', () => Header.toggleMenu());
	

	}	
};
